<section class="card">
    <div class="card-body">
        <form class="cat__app__profile__container py-0" #emailForm="ngForm">
            <div class="row">
                <div class="col-12 col-xl-6">
                    <div class="row">
                        <div class="col-12 mb-1 mb-md-3">
                            <h4 class="text-black profile-table-title"><strong>Email</strong></h4>
                        </div>
                        <div class="col-12">
                            <table class="table-edit">
                                <thead class="table-head">
                                    <th class="max-width-150">Email</th>
                                    <th class="contact-type-input">Type</th>
                                    <th class="profile-last-col width-50">Actions</th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let email of model.emails" [class.isFavorite]="email.primary">
                                        <td class="profile-row max-width-150">
                                            <i *ngIf="email.primary" class="fa fa-star"></i>
                                            <span>{{ email.email }}</span>
                                        </td>
                                        <td class="contact-type-input">{{ email.emailType.description }}</td>
                                        <td class="actions">
                                            <i (click)="edit(email)" class="edit-btn">
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 640 640">
                                                    <title></title>
                                                    <g id="icomoon-ignore"></g>
                                                    <path fill="#cc0000" d="M611.313 28.686c-17.981-17.98-41.886-27.882-67.313-27.882-25.428 0-49.333 9.902-67.313 27.882l-408 408c-1.653 1.653-2.924 3.648-3.723 5.846l-64 176c-2.125 5.842-0.673 12.386 3.723 16.781 3.053 3.055 7.144 4.687 11.315 4.687 1.833 0 3.682-0.314 5.465-0.963l176-64c2.197-0.8 4.193-2.070 5.846-3.724l408-408c17.98-17.98 27.883-41.886 27.883-67.314s-9.902-49.333-27.883-67.313zM183.196 546.177l-140.443 51.069 51.070-140.442 354.177-354.177 89.373 89.373-354.177 354.177zM588.687 140.686l-28.687 28.687-89.373-89.373 28.687-28.687c11.936-11.936 27.806-18.509 44.686-18.509s32.75 6.574 44.687 18.51c11.936 11.936 18.51 27.806 18.51 44.686s-6.575 32.75-18.51 44.686z"></path>
                                                </svg>
                                            </i>
                                            <i  (click)="!email.primary? delete(email) : false" [ngClass]="{'fa-trash-o': !email.primary, 'fa-primary-contact': email.primary}" class="fa"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-12 mt-3">
                            <div *ngIf="!isFormVisible">
                                <a class="profile-add-more"
                                   (click)="create()"
                                   id="profile-PrimaryEmail-Btn">
                                    Add Email
                                </a>
                            </div>
                            <form #form="ngForm" *ngIf="isFormVisible" class="row mt-3 d-flex align-items-center">
                                <div class="col-12 col-md-6 col-sm-6">
                                    <div class="d-flex flex-column form-group py-0">
                                        <label class="form-control-label" for="profile-Email">E-mail Address</label>
                                        <input type="email"
                                               class="form-control"
                                               name="email"
                                               [(ngModel)]="editModel.email"
                                               #emailControl="ngModel"
                                               pattern="^(['a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                                               required
                                               id="profile-Email">
                                        <div class="form-control-error"
                                             *ngIf="!emailControl.valid && (emailControl.touched || state.isSubmitted)">
                                            <ul>
                                                <li *ngIf="emailControl?.errors?.required">Email is required.</li>
                                                <li *ngIf="emailControl?.errors?.pattern">Invalid email.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3 col-sm-6">
                                    <div class="d-flex flex-column form-group py-0">
                                        <label class="form-control-label" for="profile-Email-Type">Type</label>
                                        <select class="form-control"
                                                name="emailType"
                                                [(ngModel)]="editModel.emailType.emailTypeID"
                                                #emailTypeControl="ngModel"
                                                required
                                                id="profile-Email-Type">
                                            <option class="form-check" *ngFor="let option of dictData.EmailType" [ngValue]="option.cmgmtEmailTypeId">
                                                {{ option.description }}
                                            </option>
                                        </select>
                                        <div class="form-control-error"
                                             *ngIf="!emailTypeControl.valid && (emailTypeControl.touched || state.isSubmitted)">
                                            <ul>
                                                <li *ngIf="emailTypeControl?.errors?.required">Email Type is required.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-sm-12">
                                    <div class="d-flex align-items-center pt-4">
                                        <label class="form-control-label custom-control custom-checkbox" for="profile-Email-Primary">
                                            <input class="form-check-input custom-control-input"
                                                   type="checkbox"
                                                   id="profile-Email-Primary"
                                                   [checked]="editModel.primary"
                                                   (change)="editModel.primary = !editModel.primary">
                                            <span class="custom-control-label"></span>
                                            <span class="custom-control-description">Set As Primary</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12 save-profile-changes">
                                    <button type="button"
                                            class="btn btn-primary mr-2 mr-md-3"
                                            (click)="save()">Save</button>
                                    <button type="button"
                                            class="btn btn-outline-primary"
                                            (click)="cancel()">Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</section>
